<div class="d-none d-lg-flex">
  <button
    class="btn add-card bg-add-card border-add-card d-flex flex-column align-items-center justify-content-center"
    (click)="isNewVersion ? navigateToAddCard() : openCardModal(addNewCardForm)"
  >
    <span class="icon material-icons" aria-hidden="true">add_card</span>
    <label class="font-size-14 mb-0 cursor-pointer add-card-label">{{ 'new.card.button.label' | translate }}</label>
  </button>
</div>
<div class="d-block d-lg-none w-100">
  <button
    class="btn w-100 add-card bg-add-card border-add-card d-flex flex-row align-items-center justify-content-center"
    (click)="isNewVersion ? navigateToAddCard() : openCardModal(addNewCardForm)"
  >
    <span class="icon material-icons" aria-hidden="true">add_card</span>
    <label class="font-size-14 mb-0 cursor-pointer add-card-label">{{ 'new.card.button.label' | translate }}</label>
  </button>
</div>

<ng-template #addNewCardForm let-modal>
  <div class="container p-0 overflow-auto add-new-card-modal">
    <div class="header d-flex flex-row">
      <h6 class="fw-bold">{{ 'new.card.form.title' | translate }}</h6>
      <button id="close-button" (click)="cancel()">
        <span class="material-icons-outlined"></span>
      </button>
    </div>
    <div class="content">
      <fgbcl-top-up-address
        [regex]="regex"
        [topUpAddressConfig]="topUpAddressConfig"
        [hidden]="hideAddress"
        (submittedAddress)="submittedAddress($event)"
      ></fgbcl-top-up-address>
      <!-- Loading -->
      <ng-container *ngIf="loading">
        <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
      </ng-container>
      <div id="payment-gateway-area"></div>
      <div *ngIf="showCancelButton" class="payment-action-buttons">
        <button id="cancel-button" class="btn text-danger w-50 fw-bold" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
